<template>
  <div>
  <el-form :model="loginForm" :rules="fieldRules" ref="loginForm" label-position="left" label-width="0px" class="demo-ruleForm login-container">
    <span class="tool-bar">
      <!-- 主题切换 -->
      <theme-picker style="float:right;" class="theme-picker" :default="themeColor" @onThemeChange="onThemeChange"></theme-picker>
      <!-- 语言切换 -->
      <!-- <lang-selector class="lang-selector"></lang-selector>    -->
    </span>
    <h2 class="title" style="padding-left:22px;">{{$t('Login.title')}}</h2>
    <el-form-item prop="account">
      <el-input type="text" v-model="loginForm.account" auto-complete="off" :placeholder="$t('Login.account')"></el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input type="password" v-model="loginForm.password" auto-complete="off" :placeholder="$t('Login.password')"></el-input>
    </el-form-item>
    <el-form-item >
      <el-col :span="12">
        <el-form-item prop="captcha">
          <el-input type="test" v-model="loginForm.captcha" auto-complete="off" :placeholder="$t('Login.captcha')"
            style="width: 100%;">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col class="line" :span="1">&nbsp;</el-col>
      <el-col :span="11">
        <el-form-item>
            <img style="width: 100%;" class="pointer" :src="loginForm.src" @click="refreshCaptcha">
        </el-form-item>
      </el-col>
    </el-form-item>
    <!-- <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox> -->
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:30%;" @click.native.prevent="reset">{{$t('Login.reset')}}</el-button>
      <el-button type="primary" style="width:30%;" @click.native.prevent="login" :loading="loading">{{$t('Login.login')}}</el-button>
    </el-form-item>
  </el-form>
  <footer class="app-footer">
    <div class="footer-content">
      <span class="copyright">© 2024 摩石供应链</span>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">赣ICP备2024032648号-1</a>
    </div>
  </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import ThemePicker from "@/components/ThemePicker"
import LangSelector from "@/components/LangSelector"

export default {
  name: 'Login',
  components:{
    ThemePicker,
    LangSelector
  },
  data() {
    return {
      loading: false,
      loginForm: {
        account: '',
        password: '',
        captcha:'',
        src: ''
      },
      fieldRules: {
        account: [
          { required: true, message: this.$t('Login.message.inputAccount'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('Login.message.inputPassword'), trigger: 'blur' }
        ]
        ,
        captcha: [
          { required: true, message: this.$t('Login.message.inputCaptcha'), trigger: 'blur' }
        ]
      },
      checked: true
    }
  },
  methods: {
    findLocalId: function (){
      let userName = this.loginForm.account
      let userObj = {'name':userName}
      this.$api.user.findByName(userObj).then((res) =>{
          if(res.msg != null) {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          } else {
            if(res.data == null){
              this.$message({
                message: this.$t('Login.message.invalidAccount'),
                type: 'error'})
            } else {
              let localeId=res.data["localeId"]
              let language=res.data["language"]
              if(localeId!='' && localeId!=null && language!='' && language!=null){
                sessionStorage.setItem('localeId', localeId)
                sessionStorage.setItem('language', language)
                this.$i18n.locale = language
                this.$store.commit('menuRouteLoaded', false) // 要求重新加载导航菜单
                this.$router.push('/')  // 登录成功，跳转到主页
              } else {
                this.$message({
                  message: this.$t('Login.message.InvalidLanguage'),
                  type: 'error'
                })
              }
            }
          }
          this.loading = false
        })
    },
    login: function (){
      this.loading = true
      let userInfo = {account:this.loginForm.account, password:this.loginForm.password, captcha:this.loginForm.captcha}
      this.$api.login.login(userInfo).then((res) => {
          if(res.msg != null) {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          } else {
            // 登录成功后：拦截器会保存 username（key=admin_user）和 token（key=admin_access_token_{账号}）
            this.findLocalId()
          }
        }).catch((res) => {
          this.$message({
          message: res.message,
          type: 'error'
          })
        });
      this.loading = false
    },
    refreshCaptcha: function(){
      this.loginForm.src = this.global.baseUrl + "/captcha.jpg?t=" + new Date().getTime();
    },
    reset() {
      this.$refs.loginForm.resetFields()
    },
    // 切换主题
    onThemeChange: function(themeColor) {
      this.$store.commit('setThemeColor', themeColor)
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  computed:{
    ...mapState({
      themeColor: state=>state.app.themeColor
    })
  }
}
</script>

<style lang="scss" scoped>
  .login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 100px auto;
    width: 250px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }

  .app-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: center;
    background-color: #f8f8f8;
    border-top: 1px solid #e7e7e7;
    padding: 10px 0;
    color: #666;  /* 新增字体颜色 */
    font-size: 12px;  /* 推荐字号 */
  }

  .footer-content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  .app-footer a {
    color: #666;  /* 链接颜色 */
    text-decoration: none;
  }

  .app-footer a:hover {
    color: #444;  /* 悬停颜色 */
    text-decoration: underline;
  }

  .copyright {
    letter-spacing: 0.5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue